import React, { createContext, useContext, useEffect, useRef } from "react"
import Lenis from "lenis"

const LenisContext = createContext(null)

export const LenisProvider = ({ children }) => {
  const lenisRef = useRef(null)

  useEffect(() => {
    if (typeof window === "undefined") return

    const prefersReducedMotion = window.matchMedia?.(
      "(prefers-reduced-motion: reduce)",
    )?.matches

    const isTouchDevice =
      "ontouchstart" in window || navigator.maxTouchPoints > 0

    const NO_SMOOTHING = prefersReducedMotion || isTouchDevice

    const lenis = new Lenis({
      smoothWheel: true,
      smoothTouch: true,

      // lerp = 1 means "jump to target"
      lerp: 0.6,

      // Keep scroll speed normal
      wheelMultiplier: 1,

      normalizeWheel: true,
      gestureOrientation: "vertical",
    })

    lenisRef.current = lenis

    let frame
    const raf = time => {
      lenis.raf(time)
      frame = requestAnimationFrame(raf)
    }

    frame = requestAnimationFrame(raf)

    return () => {
      cancelAnimationFrame(frame)
      lenis.destroy()
    }
  }, [])

  return (
    <LenisContext.Provider value={lenisRef}>{children}</LenisContext.Provider>
  )
}

export const useLenis = () => {
  return useContext(LenisContext)?.current || null
}
